"use strict";

const VISIBLE_CLASS = "visible";

const SELECTORS = {
    MESSAGE: ".js-message",
    MESSAGE_BUTTON: ".js-message__close",
    BODY: "body",
    INNER: ".global-alert__inner"
};

function showMessage(elem) {
    document.querySelector(SELECTORS.BODY).classList.add("js-message-active");
    elem.classList.add(VISIBLE_CLASS);
}

function hideMessage(elem) {
    document.querySelector(SELECTORS.BODY).classList.remove("js-message-active");
    return elem.classList.remove(VISIBLE_CLASS);
}

export function init() {
    const messages = document.querySelectorAll(SELECTORS.MESSAGE);

    if (messages.length === 0) {
        return false;
    }

    if (messages.length) {
        messages.forEach(message => {
            const messageId = message.getAttribute("data-message-id");
            const messageStorageKey = "app.message-hidden-" + messageId;
            const messageButton = message.querySelector(SELECTORS.MESSAGE_BUTTON);
            let isHidden;

            try {
                isHidden = localStorage.getItem(messageStorageKey);
            } catch (e) {
                console.warn(e);
            }

            if (!isHidden) {
                showMessage(message);
            }

            messageButton.addEventListener("click", function (evt) {
                evt.preventDefault();
                hideMessage(message);

                try {
                    localStorage.setItem(messageStorageKey, true);
                } catch (e) {
                    console.warn(e);
                }
            });
        });
    }
}
